module.exports = __webpack_public_path__ + "static/media/boyuan.f8dc7423.png";